/* eslint-disable @typescript-eslint/no-shadow */
import { Ref } from '@nuxtjs/composition-api';
import { throttle } from 'lodash-es';

import { ISwiperState } from '../types/ISwiper';
import { handleSwipe, moveSwiper } from './swiperTransitions';

function findTagA(element: HTMLElement): HTMLElement | null {
  if (element.tagName === 'A') {
    return element;
  }

  if (element.parentNode) {
    return findTagA(element.parentNode as HTMLElement);
  }

  return null;
}

function preventEventCall(event: Event, isPrevented: boolean): void {
  if (!(event.type === 'mouseup' || event.type === 'touchend')) {
    return;
  }

  const nodeTagA = findTagA(event.target as HTMLElement);

  if (nodeTagA) {
    if (isPrevented) {
      nodeTagA.onclick = (eventInside: Event) => {
        eventInside.preventDefault();
      };
    } else {
      nodeTagA.onclick = () => {};
    }
  }
}
export function endMove(event: Event, swiperState: Ref<ISwiperState>) {
  swiperState.value.moveFinished = true;
  const swipeDiff = swiperState.value.mousePositionStart - swiperState.value.lastTouchPosition;
  const blockEventCall = !(swipeDiff > -5 && swipeDiff < 5);

  preventEventCall(event, blockEventCall);
}

// eslint-disable-next-line max-len
export const swiperTouchEvent = (swiperState: Ref<ISwiperState>, swiperEventHandler: (e: TouchEvent, swiperState: Ref<ISwiperState>) => void) => (e: TouchEvent): void => {
  swiperEventHandler(e, swiperState);
};

// eslint-disable-next-line max-len
export const swiperMouseEvent = (swiperState: Ref<ISwiperState>, swiperEventHandler: (e: MouseEvent, swiperState: Ref<ISwiperState>) => void) => (e: MouseEvent): void => {
  swiperEventHandler(e, swiperState);
};

export function onMouseDown(event: MouseEvent, swiperState: Ref<ISwiperState>): void {
  event.preventDefault();
  // swiperState.transitionDuration = 0
  swiperState.value.swipeStartTime = Date.now();
  swiperState.value.mousePositionStart = event.clientX;
  swiperState.value.lastTouchPosition = event.clientX;
  swiperState.value.transitionDuration = 0;

  const throttleMouse = throttle(
    (event) => {
      swiperState.value.moveFinished = false;
      moveSwiper(event.clientX, swiperState.value);
    },
    20,
    { trailing: false },
  );

  function onMouseUp(event: MouseEvent): void {
    swiperState.value.transitionDuration = 300;

    document.removeEventListener('mouseup', onMouseUp);
    document.removeEventListener('mousemove', throttleMouse);
    endMove(event, swiperState);
    handleSwipe(event.clientX, swiperState.value);
  }

  document.addEventListener('mouseup', onMouseUp);
  document.addEventListener('mousemove', throttleMouse);
}

export function startTouch(event: TouchEvent, swiperState: Ref<ISwiperState>): void {
  // swiperState.transitionDuration = 0
  swiperState.value.swipeStartTime = Date.now();
  swiperState.value.mousePositionStart = event.touches[0].clientX;
  swiperState.value.lastTouchPosition = event.touches[0].clientX;
  swiperState.value.transitionDuration = 0;

  const throttleTouch = throttle(
    (event) => {
      swiperState.value.moveFinished = false;
      moveSwiper(event.touches[0].clientX, swiperState.value);
    },
    20,
    { trailing: false },
  );

  function onTouchUp(event: TouchEvent): void {
    swiperState.value.transitionDuration = 300;
    document.removeEventListener('touchend', onTouchUp);
    document.removeEventListener('touchmove', throttleTouch);
    endMove(event, swiperState);
    handleSwipe(swiperState.value.lastTouchPosition, swiperState.value);
  }

  document.addEventListener('touchend', onTouchUp);
  document.addEventListener('touchmove', throttleTouch);
}
